// Mock data for Skinplicity Wellness (frontend-only). Replace with backend later.

export const site = {
  name: "Skinplicity",
  tagline: "Professional Aesthetic Medical Center",
  bookUrl: "https://www.vagaro.com/skinplicity1/book-now",
  servicesUrl: "https://www.vagaro.com/skinplicity1/services",
  logo: "/skinplicity-logo-t.png",
  instagram: "https://www.instagram.com/skinplicity_24",
  locations: ["Covington, KY", "Independence, KY", "Hyde Park, OH"],
};

export const hero = {
  eyebrow: "Professional Aesthetic Medical Center",
  titleLines: ["Rejuvenate", "Refresh", "Renew"],
  subtitle:
    "Our treatments are more than just skin deep \u2014 they're an investment in your wellbeing, helping you radiate confidence both inside and out.",
};

export const about = {
  eyebrow: "Transform & Radiate",
  heading: "Who We Are",
  body:
    "At Skinplicity, our mission is to empower individuals to feel confident and comfortable in their own skin by providing personalized, innovative, and high-quality aesthetic treatments in a tranquil and welcoming environment. We are dedicated to enhancing beauty, promoting wellness, and fostering self-care \u2014 all while delivering exceptional results and exceeding our clients' expectations.",
  highlights: [
    { value: "Medical Grade", label: "Products & Treatments" },
    { value: "3 Locations", label: "Covington \u00b7 Independence \u00b7 Hyde Park" },
    { value: "Certified APRNs", label: "Advanced Practice Nurses" },
  ],
};

export const services = [
  {
    icon: "Syringe",
    title: "Botox / Xeomin",
    desc: "Diminishes fine lines and wrinkles by gently relaxing targeted facial muscles.",
  },
  {
    icon: "Droplet",
    title: "Dermal Fillers",
    desc: "A nonsurgical method to restore lost volume, contour and youthful fullness.",
  },
  {
    icon: "Sparkles",
    title: "PDO Smooth Threads",
    desc: "Tightens and smooths the skin by naturally boosting collagen production.",
  },
  {
    icon: "Waves",
    title: "Microneedling",
    desc: "Offered in two advanced forms \u2014 Vital W and APGF \u2014 for renewed texture.",
  },
  {
    icon: "Zap",
    title: "Laser & IPL",
    desc: "Laser hair removal and IPL facial treatments for clear, even-toned skin.",
  },
  {
    icon: "Scan",
    title: "Skin Tightening",
    desc: "Viora skin tightening and microdermabrasion for a firm, refreshed glow.",
  },
];

export const pricing = [
  { name: "Botox / Xeomin", price: "From $11", unit: "per unit" },
  { name: "Dermal Fillers", price: "From $300", unit: "per half syringe" },
  { name: "PDO Smooth Threads", price: "From $25", unit: "per thread" },
  { name: "Microneedling \u2014 Vital W", price: "From $250", unit: "per session" },
  { name: "Microneedling \u2014 APGF", price: "From $400", unit: "per session" },
  { name: "Laser Hair Removal", price: "From $150", unit: "per area" },
  { name: "IPL Facial Treatment", price: "$100", unit: "per session" },
  { name: "Viora Skin Tightening", price: "$150", unit: "per session" },
];

export const team = [
  { name: "Mandy Race", role: "APRN", photo: "/team-mandy.jpg" },
  { name: "Ali Goodridge", role: "APRN", photo: "/team-ali.jpg" },
  { name: "Mindy Benjamin", role: "APRN", photo: "/team-mindy.jpg" },
  { name: "Janice Dalessandro", role: "Registered Esthetician", photo: null },
];

export const heroBg = "/hero-bg.png";

export const contact = {
  address: "437 Commonwealth Avenue, Erlanger, KY",
  phone: "(859) 391-7773",
  email: "hello@skinplicitywellness.com",
  hours: [
    { day: "Monday \u2013 Friday", time: "9:00 AM \u2013 6:00 PM" },
    { day: "Saturday", time: "10:00 AM \u2013 4:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};


export const locations = [
  {
    name: "Skinplicity at Aesthetic Health & Wellness",
    address: "802 Scott St, Covington, KY 41011",
    phone: "(859) 279-3066",
    mapQuery: "802 Scott St, Covington, KY 41011",
    directions: "https://maps.app.goo.gl/huVVKSaAsgAj7vJi9",
  },
  {
    name: "Skinplicity \u2013 Independence",
    address: "Independence, KY",
    phone: "(859) 391-7773",
    mapQuery: "Skinplicity Independence KY",
    directions: "https://www.google.com/maps/search/Skinplicity+Independence+KY",
  },
  {
    name: "Skinplicity \u2013 Hyde Park",
    address: "Hyde Park, Cincinnati, OH",
    phone: "(859) 391-7773",
    mapQuery: "Skinplicity Hyde Park Cincinnati OH",
    directions: "https://www.google.com/maps/search/Skinplicity+Hyde+Park+Cincinnati+OH",
  },
];
